import {Component} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Session} from "../../services/Session";
import {Config} from "../../services/Config";
import {Router} from '@angular/router';

@Component({
  selector: 'login',
  templateUrl: './register.html',
})
export class RegisterCmp {
  public Session:Session;
  public http:HttpClient;
  public config:Config;
  public loading;
  public router;
  public error = 0;
  public password = '';
  public passwordRules = {
    minLength: false,
    hasLower: false,
    hasUpper: false,
    hasDigit: false,
    hasSpecial: false,
  };

  constructor(Session:Session, http:HttpClient, config:Config, router:Router) {
    this.Session = Session;
    this.http = http;
    this.config = config;
    this.router = router;
  }

  clearErrors() {
    this.error = 0;
  }

  onPasswordInput() {
    this.passwordRules.minLength = this.password.length >= 8;
    this.passwordRules.hasLower = /[a-z]/.test(this.password);
    this.passwordRules.hasUpper = /[A-Z]/.test(this.password);
    this.passwordRules.hasDigit = /[0-9]/.test(this.password);
    this.passwordRules.hasSpecial = /[^a-zA-Z0-9]/.test(this.password);
  }

  isPasswordValid():boolean {
    return this.passwordRules.minLength && this.passwordRules.hasLower &&
      this.passwordRules.hasUpper && this.passwordRules.hasDigit && this.passwordRules.hasSpecial;
  }

  register(username:string) {
    if (!this.isPasswordValid()) {
      return;
    }
    this.loading = true;
    this.error = 0;
    this.http.post(this.config.apiUrl + '/register', JSON.stringify({username: username, password: this.password}),
      {responseType: 'text', observe: 'response'}).subscribe((response) => {
      this.Session.setToken(response.body);
      this.Session.loadUser();
      this.router.navigate(['']);
      this.loading = false;
    }, (response)=> {
      this.error = response.status;
      this.loading = false;
    });
  }
}
